import React from "react";

import { useGetCurrentAlerts } from "api/api-hooks/alerts-hooks";
import { SelectButton } from "primereact/selectbutton";
import { Sidebar } from "primereact/sidebar";
import { T } from "services/lang/LanguageService";
import useAlertsStore from "store/alerts-store";
import AlertItem from "./AlertItem";

export default function AlertsPanel() {
  const { isPanelOpen, closePanel, filter, setFilter } = useAlertsStore();
  const { data: alerts, isLoading } = useGetCurrentAlerts();

  const filterOptions = [
    { label: T("word.unread"), value: "unacknowledged" },
    { label: T("word.all"), value: "all" },
  ];

  const filteredAlerts = alerts?.filter(alert => (filter === "all" ? true : !alert.isAcknowledged));

  const sortedAlerts = filteredAlerts?.sort((a, b) => {
    const priorityOrder = { CRITICAL: 0, WARNING: 1, NOTICE: 2 };
    const priorityDiff = priorityOrder[a.priority] - priorityOrder[b.priority];
    if (priorityDiff !== 0) return priorityDiff;
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
  });

  return (
    <Sidebar
      visible={isPanelOpen}
      onHide={closePanel}
      position="right"
      header={T("word.alerts")}
      style={{ width: "400px" }}
    >
      <div className="flex flex-column gap-3">
        <SelectButton value={filter} options={filterOptions} onChange={e => setFilter(e.value)} />

        {isLoading && <div>{T("word.loading")}</div>}

        {sortedAlerts?.length === 0 && <div className="text-center text-500 p-4">{T("alert.no-alerts")}</div>}

        {sortedAlerts?.map(alert => <AlertItem key={alert.id} alert={alert} />)}
      </div>
    </Sidebar>
  );
}
